module.exports = __webpack_public_path__ + "img/hero-overlay.54e4d23b.png";